import { createFileRoute, Outlet } from '@tanstack/react-router';

// These campaign pages sit outside the Broadcasts list's migration frame.
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests',
)({
  component: Outlet,
});
